var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibleIssues.length)?_c('div',{staticClass:"sharer-billing-issues"},_vm._l((_vm.visibleIssues),function(issue,index){return _c('el-alert',{key:issue.code + '-' + index,attrs:{"type":_vm.alertType(issue),"title":_vm.alertTitle(issue),"description":_vm.alertDescription(issue),"closable":false,"show-icon":"","role":"alert"}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }